<template>
  <div>
    <van-nav-bar
      title="轻客洗衣卡充值业务"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="bigBox"></div>
    <div style="padding: 10px">
      <div v-if="pageType == 10" style="text-align: left">
        <div style="padding-top: 20px">请输入您的卡号：</div>
        <div style="padding-top: 10px"></div>
        <div class="fieldBox">
          <van-field v-model="cardNumber" placeholder="请输入卡号" />
        </div>
        <div style="padding-top: 40px"></div>
        <van-button type="primary" color="#46C9BA" block @click="checkCard"
          >下一步</van-button
        >
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
        <div style="padding-top: 40px"></div>
        <div class="hints">
          卡充值流程：
          <div>1、请核对充值卡号的归属信息无误后再进行充值。</div>
        </div>
      </div>
      <div v-else style="text-align: left">
        <div>
          <van-field readonly label="卡号：" :value="cardNumber"  />
          <van-field readonly label="余额：" :value="balance"  />
          <van-field readonly label="卡类型：" :value="cardType"  />
        </div>

        <div style="padding-top: 20px"></div>
        <!-- <div class="hint greend" id="balanceInfo" style="text-align: center;color: #46C9BA;">
          <span v-on:click="queryBalance" style="color: #46C9BA;font-size: 16pt;">查询余额</span>
        </div>
        <div style="padding-top: 20px;"></div> -->
        <div class="topUpBox">
          <div
            class="topUpBoxLi"
            v-for="(item, key) in money"
            :key="key"
            :class="colorType === key ? 'topUpBoxLiIf' : ''"
            @click="change(key, item.value)"
          >
            <div
              class="topUpBoxLiP"
              :class="colorType === key ? 'topUpBoxLiPIf' : ''"
            >
              <strong class="LiSpan">{{ item.name }}</strong
              >元
            </div>
            <div
              class="topUpBoxLiSpan"
              :class="colorType === key ? 'topUpBoxLiSpanIf' : ''"
            >
              售价{{ item.value }}元
            </div>
          </div>
        </div>
        <div style="padding-top: 35px"></div>
        <van-button
          type="primary"
          color="#46C9BA"
          :disabled="type"
          block
          v-on:click="verifyAccount"
          >充值</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
function getUrlKey(name) {
  //获取url 参数
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

function getCodeApi(state) {
  //获取code
  let urlNow = encodeURIComponent(window.location.href);
  let scope = "snsapi_base"; //snsapi_userinfo   //静默授权 用户无感知
  let appid = "wxd104040ca687111a";
  let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
  window.location.replace(url);
}

import wx from "weixin-js-sdk";

export default {
  mounted() {
    let code = getUrlKey("code"); //获取url参数code
    if (code) {
      //拿到code， code传递给后台接口换取opend
      this.code = code;

      let currentUrl = location.href.split("#")[0];

      let data = new FormData();
      data.append("code", this.code);
      data.append("url", currentUrl);
      this.$axios
        .post("/api/smartcard/getOpenIdByCode", data)
        .then((res) => {
          if (res.data.success) {
            this.openId = res.data.userObject.openId;

            let dd = res.data.userObject;

            console.log(dd);

            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: dd.appId, // 必填，公众号的唯一标识
              timestamp: dd.timestamp, // 必填，生成签名的时间戳
              nonceStr: dd.nonceStr, // 必填，生成签名的随机串
              signature: dd.signature, // 必填，签名，见附录1
              jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
          } else {
            this.$toast.fail("加载openId失败，原因：" + res.data.msg + "!");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toast.fail("加载openId失败!");
        });
    } else {
      getCodeApi("qksmartcardfill2020");
    }
  },
  data() {
    return {
      pageType: 10,
      cardType: "轻客一卡通",
      cardNumber: "",
      balance: "0.00",
      verifyCode: "",
      showPicker: false,
      columns: ["轻客一卡通"],
      money: [{ name: "100", value: "100" }],
      type: false,
      colorType: "",
      fillAmt: "",
      code: "",
      openId: "",
      fid: "",
      dataList: [],
    };
  },
  methods: {
    //   后退
    onClickLeft() {
      this.$router.go(-2);
    },

    change(key, value) {
      this.colorType = key;
      this.fillAmt = value;
    },
    onConfirm(value, key) {
      var that = this;
      that.cardType = value;
      that.dataList.forEach((item, key) => {
        if (item.cardType == value) {
          that.fid = item.fid;
          that.balance = item.balance;
        }
      });
      this.getMoneyList(that.fid);
    },

    getMoneyList(fid) {
      let data = new FormData();
      data.append("cardId", fid);
      this.$axios
        .post("/api/smartcard/get-fillamt-list-by-cardid", data)
        .then((res) => {
          if (res.data.success) {
            this.money = res.data.userObject;
            this.pageType = 20;
            this.showPicker = false;
          } else {
            this.$toast.fail("加载充值信息失败，原因：" + res.data.msg + "!");
          }
          //加载状态结束
          this.finished = true;
        })
        .catch((error) => {
          this.finished = true;
          this.$toast.fail("加载充值信息失败!");
        });
    },
    checkCard() {
      let data = new FormData();
      data.append("cardNumber", this.cardNumber);
      this.$axios
        .post("/api/smartcard/get-cardtype-list-by-cardnumber", data)
        .then((res) => {
          if (res.data.success) {
            var rs = res.data.userObject;
            this.dataList = rs;
            if (rs.length == 1) {
              this.cardType = rs[0].cardType;
              this.balance = rs[0].balance;
              this.fid = rs[0].fid;
              this.getMoneyList(this.fid);
            } else if (rs.length > 1) {
              this.columns = [];
              rs.forEach((item, key) => {
                this.columns.push(item.cardType);
              });
              this.showPicker = true;
            } else {
              this.$toast.fail("加载卡信息失败");
            }
          } else {
            this.$toast.fail("加载卡信息失败，原因：" + res.data.msg + "!");
          }
          //加载状态结束
          this.finished = true;
        })
        .catch((error) => {
          this.finished = true;
          this.$toast.fail("加载卡信息失败!");
        });
    },
    queryBalance() {
      if (this.cardType == null || this.cardType.length == 0) {
        this.$toast.fail("请选择卡类型!");
        return;
      }

      if (this.cardNumber == null || this.cardNumber.length == 0) {
        this.$toast.fail("请输入正确的卡号!");
        return;
      }
      let data = new FormData();
      data.append("cardType", this.cardType);
      data.append("cardNumber", this.cardNumber);
      this.$axios
        .post("/api/smartcard/query-card-balance", data)
        .then((res) => {
          if (res.data.success) {
            this.$toast.success("卡内余额：" + res.data.userObject);
          } else {
            this.$toast.fail("查询余额失败，原因：" + res.data.msg + "!");
          }
        })
        .catch((error) => {
          this.$toast.fail("查询余额失败!");
        });
    },

    verifyAccount() {
      if (this.cardType == null || this.cardType.length == 0) {
        this.$toast.fail("请选择卡类型!");
        return;
      }

      if (this.cardNumber == null || this.cardNumber.length == 0) {
        this.$toast.fail("请输入正确的卡号!");
        return;
      }

      if (this.fillAmt == null || this.fillAmt.length == 0) {
        this.$toast.fail("请选择充值金额!");
        return;
      }

      let data = new FormData();
      data.append("cardType", this.cardType);
      data.append("cardNumber", this.cardNumber);
      data.append("fillAmt", this.fillAmt);
      data.append("openId", this.openId);

      this.$axios
        .post("/api/smartcard/fillpay", data)
        .then((res) => {
          if (res.data.success) {
            let data = res.data.userObject;
            wx.chooseWXPay({
              timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
              package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
              signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: data.paySign, // 支付签名
              success: function (res) {},
              fail: function (res) {},
            });
          } else {
            this.$toast.fail("充值失败，原因：" + res.data.msg + "!");
          }
        })
        .catch((error) => {
          this.$toast.fail("充值失败!");
        });
    },
  },
};
</script>
<style>
.bigBox {
  margin-top: 5pt;
  height: 145pt;
  width: 100%;
  background-image: url("/static/images/img_qkier.jpg");
  background-size: cover;
  background-position: center;
}
.fieldBox {
  border-radius: 10px;
  padding: 4px;
  border: 1px solid #bbbbbb;
}
.hint {
  margin-top: 20rpx;
  text-align: center;
}
.hints {
  /* white-space: pre-wrap; */
  text-align: left;
  font-size: 10pt;
  color: red;
}
.greend {
  color: #46c9ba;
}

.red {
  color: red;
}

.topUpBox {
  margin-top: 40rpx;
  width: 100%;
}

.topUpBoxLi {
  display: inline-block;
  width: 30%;
  height: 50pt;
  /* background-color: rgb(225, 236, 245); */
  background-color: #e8f3ff;
  margin-left: 7pt;
  margin-top: 7pt;
  border-radius: 7pt;
  text-align: center;
}

.topUpBoxLiP {
  color: #3298ff;
  font-size: 12pt;
  margin: 10pt 0 0 0;
}

.LiSpan {
  font-size: 14pt;
}

.topUpBoxLiSpan {
  font-size: 10pt;
  /* color: rgb(179, 179, 179); */
  color: rgb(32, 32, 32);
}

.topUpBoxLiIf {
  /* background-color: rgb(240, 240, 240); */
  background-color: #46c9ba;
}

.topUpBoxLiPIf {
  /* color:rgb(83, 83, 83) */
  color: #fff;
}

.topUpBoxLiSpanIf {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/topUpRecharge/topUpRecharge.vue